
// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('product.saleschannels', {
        url: '/saleschannels',
        views: {'productList@product': {
            templateUrl: 'main/product/saleschannels/saleschannels.tpl.html',
            controller: 'SalesChannelsController as vm'
        }},
        resolve: {
            salesChannels: salesChannelsResolver
        }
    });
}

// @ngInject
function salesChannelsResolver(SalesChannelsApiService) {
    return SalesChannelsApiService.getSalesChannels();
}

// @ngInject
function SalesChannelsController($rootScope, $state, $scope, salesChannels, SalesChannelsApiService,loadSpinnerService) {
    var vm = this;

    vm.currentUser = $rootScope.currentUser;

    vm.salesChannels = salesChannels;
    vm.selectedSalesChannelId = 0;
    vm.searchTerm = "";
    vm.currentPage = 1;
    vm.itemsPerPage = null;

    vm.searchTermChange = searchTermChange;

    activate();

    function activate() {
        $scope.$watch(function() { return $state.params.salesChannelId; }, function(newValue, oldValue) {
            vm.selectedSalesChannelId = parseInt($state.params.salesChannelId, 10);
        });
        $rootScope.$on('SalesChannel.Changed', function(event, response) {
            loadSalesChannels();
        });
    }

    function loadSalesChannels() {
        loadSpinnerService.start('mainSpinner');
        SalesChannelsApiService.getSalesChannels(vm.currentPage,vm.searchTerm,vm.itemsPerPage).then(function(response) {
            vm.salesChannels = response;
        }).finally(function () {
            loadSpinnerService.stop('mainSpinner',{force: true});
        });
    }

    function searchTermChange() {
        vm.currentPage = 1;
        loadSalesChannels();
    }

}

angular
    .module('product.saleschannels', ['saleschannels.api', 'saleschannels.saleschannel'])
    .config(stateConfig)
    .controller('SalesChannelsController', SalesChannelsController);
